// App
export const BACK_BUTTON = 'backButton'
export const GET_COUNTRY_DATA = 'getCountryData'

// Auth
export const AUTH_ID = 'authId'
export const AUTH_USER = 'authUser'
export const WAIT_DAYS = 'waitDays'
export const RETURN_AFTER_DAY = 'returnAfterDay'
export const IS_AUTHENTICATED = 'isAuthenticated'
export const NEEDS_TO_UPDATE_PAYMENT_METHOD = 'needsToUpdatePaymentMethod'
export const USER_COUNTRY = 'userCountry'
export const GET_ADDITIONAL_PAYMENT_DATA = 'getAdditionalPaymentData'

// Payment
export const OPEN_PAYMENTS = 'openPayments'

// Payment Contract
export const PAYMENT_CONTRACTS = 'paymentContracts'

export const ACTIVE_BOXER = 'activeBoxer'

// Flags
export const IS_TWO_FOR_ONE_CAMPAIGN = 'isTwoForOneCampaign'
export const IS_TWO_FOR_ONE_CAMPAIGN_LAST_DAY = 'isTwoForOneCampaignLastDay'
export const IS_FLAGS_FETCHED = 'isFlagsFetched'
